import { Search } from 'lucide-react';

import { cn } from '@/lib/utils';

type DropdownSearchProps = {
  value: string;
  placeholder: string;
  className?: string;
  onChange: (value: string) => void;
};

export const DropdownSearch = (props: DropdownSearchProps) => {
  const { value, placeholder, className, onChange } = props;

  return (
    <div className={cn('relative border-b-0 p-0', className)}>
      <Search className="text-muted-foreground pointer-events-none absolute top-1/2 left-3 block size-5 -translate-y-1/2" />
      <input
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className="placeholder:text-muted-foreground text-caption border-input bg-card focus-visible:border-primary h-9 w-full rounded-md border pr-3 pl-10 outline-none placeholder:text-xs"
      />
    </div>
  );
};
